import { Group } from '@mantine/core';
import type { Device, DeviceDYNCode } from '@types';
import { memo } from 'react';
import { DeleteDeviceButton, ConnectDeviceButton } from './DeviceActionButtons';

interface DeviceActionButtonsGroupProps {
  device: Device;
  deviceTokens: DeviceDYNCode[];
  userId: string;
  onRefresh: () => void;
  onDeleteDevice: (deviceId: string) => Promise<void>;
}

const DeviceActionButtonsGroup = memo(function DeviceActionButtonsGroup({
  device,
  userId,
  onRefresh,
  onDeleteDevice,
}: DeviceActionButtonsGroupProps) {
  const hasValidToken = false;

  return (
    <Group gap='xs'>
      {!hasValidToken && (
        <ConnectDeviceButton
          userId={userId}
          onSuccess={onRefresh}
          deviceCode={device.code || ''}
          size='xs'
        />
      )}

      <DeleteDeviceButton
        deviceId={device.id.toString() || device.code}
        deviceName={device.name || device.model}
        onDelete={async deviceId => {
          await onDeleteDevice(deviceId);
          onRefresh();
        }}
        onSuccess={onRefresh}
        variant='light'
        color='red'
        size='xs'
      />
    </Group>
  );
});

export default DeviceActionButtonsGroup;
